module.exports = __webpack_public_path__ + "static/media/monetization-control-icon.8223764b.svg";